import { FC, ReactNode } from 'react';
import { Heading, Paragraph, Spacer, Row } from '@wunder-mobility/ui-components';
import { useRequestSupportMethodsQuery } from '@/core/services/SettingsManagement.service';

interface AuthenticationLayoutT {
  title: ReactNode;
  form: ReactNode;
  footer: ReactNode;
  alignCenter?: boolean;
}

const AuthenticationLayout: FC<AuthenticationLayoutT> = ({ title, form, footer, alignCenter }) => {
  // Load the tenant's public support.methods so pre-auth footers (e.g. the Register
  // "Contact support" link) resolve to the tenant destination instead of a fallback.
  useRequestSupportMethodsQuery();

  return (
    <>
      <Heading marginBottom={4} weight="regular" size={3} align={alignCenter ? 'center' : 'left'}>
        {title}
      </Heading>
      {form}
      <Spacer />
      <Row justify={alignCenter ? 'center' : 'flex-start'}>
        <Paragraph size={4} weight="medium" align={alignCenter ? 'center' : 'left'}>
          {footer}
        </Paragraph>
      </Row>
    </>
  );
};

export default AuthenticationLayout;
